//NOTE: this calculation depends on box-sizing
//https://stackoverflow.com/a/30454127
export var getItemsLimits = function (ownerDocument, children, initialValue, initialValueAlone, getElementWidthFn // fix after https://jira.wolterskluwer.io/jira/browse/JUMPSTART-3741
) {
    if (initialValueAlone === void 0) { initialValueAlone = false; }
    if (getElementWidthFn === void 0) { getElementWidthFn = getElementWidth; }
    var limits = [];
    if (initialValueAlone) {
        limits.push(initialValue);
    }
    Array.from(children).reduce(function (prev, curr) {
        var ownWidth = getElementWidthFn(ownerDocument, curr);
        var totalWidth = Number(prev) + Math.round(ownWidth);
        limits.push(totalWidth);
        return totalWidth;
    }, initialValue);
    return limits;
};
export var getElementWidth = function (ownerDocument, element) {
    var computedStyle = ownerDocument.defaultView.getComputedStyle(element);
    var boxSizing = computedStyle.boxSizing;
    if (boxSizing != 'border-box') {
        console.log("Expected box-sizing is border-box but got ".concat(boxSizing));
    }
    // computedStyle.width on IE11 skip padding
    var ownWidth = _getElementWidth(ownerDocument, element, computedStyle);
    return ownWidth;
};
/*
    This function created for case which may happened in Angular:
    Component A:

    <div cg:if="{false}">
        <cg:content-all />
    </div>

    Component B:
    <div>
        foo
    </div>

    Story:

    <div>
        <A>
            <B></B>
        </A>
    </div>

    component "B" is created but it is not in the DOM and cg_init is called because of the nature of the <ng-container selector="*"> which is used under <cg:content-all />
    more about ng-container https://angular.io/guide/content-projection#conditional-content-projection
    we can't fix it now because it is low priority and time consuming but we will do that in the ticket https://jira.wolterskluwer.io/jira/browse/JUMPSTART-3741

    Conclusion:
     _getElementWidth function should be used if all rules below are true:
     1) if you have case like described above (real examples in Modal, Notification, Tooltip, take a look on *state._isInDOM).
     2) if everything works as expected using the getElementWidth to avoid unnecessary log in the console.
     3) mark like "fix after https://jira.wolterskluwer.io/jira/browse/JUMPSTART-3741"

*/
export var _getElementWidth = function (ownerDocument, element, computedStyle) {
    if (computedStyle === void 0) { computedStyle = ownerDocument.defaultView.getComputedStyle(element); }
    var ownWidth = element.clientWidth +
        parseFloat(computedStyle.marginLeft) +
        parseFloat(computedStyle.marginRight) +
        parseFloat(computedStyle.borderLeftWidth +
            parseFloat(computedStyle.borderRightWidth));
    return ownWidth;
};
/**
 * Return width available to place elements inside container
 */
export var getAvailableWidth = function (ownerDocument, element) {
    var computedStyle = ownerDocument.defaultView.getComputedStyle(element);
    return (parseFloat(computedStyle.width) -
        parseFloat(computedStyle.paddingRight) -
        parseFloat(computedStyle.paddingLeft));
};
export var isHidden = function (idx, firstRendered, lastRendered) {
    return idx < firstRendered || lastRendered < idx;
};
/**
 * Returns the information about how many items are visible in the available content space
 * the common use case is when you have buttons and at some size (depends on use case width or height) of the content
 * it is required to hide some of them and show the dropdown more button.
 *
 * @param availableSpace The available space (width or height) where items should be put.
 * @param itemSizes The array of items sizes (widths or heights).
 * @param menuToggleSize The size of the element which also has to be put in the content space.
 * @param selectedIndex the index of the selected index, pass -1 if there is no selected item or the selected item should not be sticky
 * @returns Interval The interval of visible items(inclusive) if none fits indexes are -1
 */
export function getDisplayedItemsInterval(availableSpace, itemSizes, menuToggleSize, selectedIndex) {
    if (selectedIndex === void 0) { selectedIndex = -1; }
    if (!itemSizes.length) {
        return {
            start: -1,
            end: -1
        };
    }
    var itemLimits = itemSizes.reduce(function (acc, item, i) {
        acc[i] = i ? item + acc[i - 1] : item;
        return acc;
    }, new Array(itemSizes.length));
    var totalItemsSize = itemLimits[itemSizes.length - 1];
    var allItemsFit = totalItemsSize <= Math.floor(availableSpace);
    if (allItemsFit) {
        // return the all items interval
        return { start: 0, end: itemSizes.length - 1 };
    }
    else {
        //determine the collapsed ranges
        var hasSelectedItem = selectedIndex >= 0;
        var availableSize = Math.floor(availableSpace - menuToggleSize);
        var selectedItemEnd = hasSelectedItem ? itemLimits[selectedIndex] : 0;
        // selected item should be visible until it doen't fit the space along with the dropdown
        var collapsedFromSelected = hasSelectedItem && (selectedItemEnd > availableSize);
        // even the selected doesn't fit - show only the toggle
        if (availableSize <= 0 || (collapsedFromSelected && itemSizes[selectedIndex] > availableSize)) {
            return { start: -1, end: -1 };
        }
        // iterate from the item selected item if the selected item is fixed(selected)
        var possibleItems = collapsedFromSelected ? itemSizes.slice(0, selectedIndex + 1).reverse() : itemSizes;
        var currentAccWidth = 0;
        var endIndex = 0;
        for (var i = 0; i < possibleItems.length; i++) {
            currentAccWidth += possibleItems[i];
            if (currentAccWidth > availableSize) {
                endIndex = i - 1;
                break;
            }
        }
        if (endIndex === -1) {
            // none items fit, return empty interval
            return {
                start: -1,
                end: -1
            };
        }
        return collapsedFromSelected ? {
            start: selectedIndex - endIndex,
            end: selectedIndex
        } : {
            start: 0,
            end: endIndex
        };
    }
}
